import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const questions = createSlice({
  name: 'browseQuestions',
  initialState,
  reducers: {
    getBrowseQuestionsRequest: handlers.getBrowseQuestionsRequest,
    getBrowseQuestionsSuccess: handlers.getBrowseQuestionsSuccess,
    getBrowseQuestionsFailure: handlers.getBrowseQuestionsFailure,
  },
});

const { actions, reducer } = questions;

export const {
  getBrowseQuestionsRequest,
  getBrowseQuestionsSuccess,
  getBrowseQuestionsFailure,
} = actions;

export default reducer;
